import React from "react"
import { Checkbox, Col, Row } from 'antd'
import type { CheckboxValueType } from 'antd/es/checkbox/Group'
import { useTranslation } from "react-i18next"
import classes from "./styles.module.css"

// Redux
import { useDispatch } from 'react-redux'
import { Routes, Municipality }  from '../../redux/mapPage/route'
import type { RootState } from '../../redux/store'
import { useSelector } from 'react-redux'

interface Props{
  icon?: any;
  header?: string;
  array: any;
  type: string;
  setDateRangeStart?: any
  setDateRangeEnd?:any
}

const CheckBoxComponent: React.FC<Props> = ({ icon, header, array, type, setDateRangeStart, setDateRangeEnd }:Props ) => {

  const { t } = useTranslation()
  const dispatch = useDispatch()

  const ReduxRoutes: any[] = useSelector((state: RootState) => state.Routes.Routes)
  const ReduxMunicipalities: any[] = useSelector((state: RootState) => state.Routes.Municipality)

  const onChange = (list: CheckboxValueType[]) => {
    type === 'routes' ? dispatch(Routes(list)) : dispatch(Municipality(list))
  }
  
  if (type === 'municipality') {
    return (
      <>
        {header && <div className={classes.divider}>{icon}<span className={classes.dividerSpan2}>{header}</span></div>}
        <Checkbox.Group style={{ width: '100%' }} onChange={onChange} defaultValue={ ReduxMunicipalities[0] && ReduxMunicipalities[0] }>
          <Row>
            <Col span={24} className={classes.checkboxGroup}>
              <Checkbox value={t('Αποκορώνου')}>{t('Αποκορώνου')}</Checkbox>
            </Col>
            <Col span={24} className={classes.checkboxGroup}>
              <Checkbox value={t('Γαύδου')}>{t('Γαύδου')}</Checkbox>
            </Col>
            <Col span={24} className={classes.checkboxGroup}>
              <Checkbox value={t('Καντάνου-Σελίνου')}>{t('Καντάνου-Σελίνου')}</Checkbox>
            </Col>
            <Col span={24} className={classes.checkboxGroup}>
              <Checkbox value={t('Κισσάμου')}>{t('Κισσάμου')}</Checkbox>
            </Col>
            <Col span={24} className={classes.checkboxGroup}>
              <Checkbox value={t('Πλατανιά')}>{t('Πλατανιά')}</Checkbox>
            </Col>
            <Col span={24} className={classes.checkboxGroup}>
              <Checkbox value={t('Σφακίων')}>{t('Σφακίων')}</Checkbox>
            </Col>
            <Col span={24} className={classes.checkboxGroup}>
              <Checkbox value={t('Χανίων')}>{t('Χανίων')}</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
    </>
  )
  }

  
  return (
    <>
      {header && <div className={classes.divider}>{icon}<span className={classes.dividerSpan2}>{t(header)}</span></div>}
      
      <Checkbox.Group style={{ width: '100%' }} onChange={onChange} defaultValue={ ReduxRoutes[0] && ReduxRoutes[0] }>
        <Row>
          {array.map((item: any) => {

            return (
              <Col span={24} key={item.id} className={classes.checkboxGroup}>
                <Checkbox value={item.id}>{t(item.name)}</Checkbox>
              </Col>
            )
          })}
        </Row>
      </Checkbox.Group>
    </>
  )
}

export default CheckBoxComponent